import { App } from 'antd';

/**
 * Hook to access Ant Design's notification API.
 * This replaces the static `notification` import from 'antd'.
 *
 * Usage:
 * ```tsx
 * import useNotification from '@/hooks/useNotification';
 *
 * function MyComponent() {
 *   const notification = useNotification();
 *
 *   const handleClick = () => {
 *     notification.success({
 *       message: 'Success!',
 *       description: 'Operation completed'
 *     });
 *   };
 * }
 * ```
 */
export default function useNotification() {
  const { notification } = App.useApp();
  return notification;
}
